import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import { config } from "../config";

const userPool = new CognitoUserPool({
  UserPoolId: config.userPoolId,
  ClientId: config.userPoolClientId,
});

export function getSession(): Promise<CognitoUserSession> {
  const user = userPool.getCurrentUser();
  if (!user) return Promise.reject(new Error("Not signed in"));
  return new Promise((resolve, reject) =>
    user.getSession((err: Error | null, session: CognitoUserSession | null) =>
      err || !session ? reject(err) : resolve(session)
    )
  );
}

export function signIn(email: string, password: string): Promise<CognitoUserSession> {
  const user = new CognitoUser({ Username: email, Pool: userPool });
  const auth = new AuthenticationDetails({ Username: email, Password: password });
  return new Promise((resolve, reject) =>
    user.authenticateUser(auth, {
      onSuccess: resolve,
      onFailure: reject,
    })
  );
}

export function signOut() {
  userPool.getCurrentUser()?.signOut();
}

export async function getToken(): Promise<string> {
  const session = await getSession();
  return session.getIdToken().getJwtToken();
}
